import angular from 'angular';
import SearchbarComponent from './searchbar.component';

const searchbarModule = angular.module('tinaba.common.components.searchbar', [])

.component('searchbar', SearchbarComponent);

export default searchbarModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/searchbar/searchbar.js
 **/